export default "__VITE_ASSET__BgTew8yw__"